module.exports = __webpack_public_path__ + "static/media/right-top.4a78d584.svg";